
import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

function ReviewCard({ review }) {
  return (
    <Card className="bg-card h-full">
      <CardContent className="pt-6">
        <div className="flex gap-1 mb-4">
          {[...Array(review.rating)].map((_, i) => (
            <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
          ))}
        </div>
        <p className="text-muted-foreground leading-relaxed mb-4 italic">
          "{review.text}"
        </p>
        <div className="border-t pt-4">
          <p className="font-semibold">{review.name}</p>
          <p className="text-sm text-muted-foreground">{review.service}</p>
        </div>
      </CardContent>
    </Card>
  );
}

export default ReviewCard;
